import store from '@/store'
import {
  connectionService,
  PERSON_UPDATE_URI,
  PERSON_FETCH_URI
} from '@leapsight/styleguide'
import { i18n } from '@leapsight/portal'

export default {
  keyGroups: {
    1: 'business_account_user',
    2: 'business_account_admin'
  },
  keyRols: {
    1: 'mrn:party_role:user',
    3: 'mrn:party_role:emergency_contact'
  },
  ROL_ID: {
    user: 1,
    contact: 2,
    emergencyContact: 3
  },
  PROFILE_ID: {
    user: 1,
    emergencyContact: 3
  },
  personFetch({ userId }) {
    return new Promise((resolve, reject) => {
      const kwArgs = connectionService.createkwArgs()
      const connection = store.getters['auth/connection']
      connection.session
        .call(PERSON_FETCH_URI, [userId], kwArgs, {})
        .then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
        .catch(err => {
          console.log(err)
        })
    })
  },
  updatePerson(
    id,
    { firstName, lastName, identifyType, identifyNumber, phones, photo }
  ) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [
        id,
        {
          first_name: firstName,
          last_name: lastName,
          identification_type: identifyType,
          identification_number: identifyNumber,
          phones: phones,
          photo
        }
      ]
      const security = connectionService.createkwArgs()
      const kwArgs = {
        ...security
      }
      const options = {}

      connection.session
        .call(PERSON_UPDATE_URI, args, kwArgs, options)
        .then(
          response => {
            resolve(response)
          },
          wampError => {
            console.log(wampError)
            reject(wampError)
          }
        )
        .catch(error => {
          console.log(error)
        })
    })
  },
  //ERRORS
  getErrorMessageByCode(code = '') {
    let strToReturn
    switch (code) {
      case 'com.magenta.error.unexpected_error':
        strToReturn = i18n.t('general.dialogComponent.text_error')
        break
      default:
        strToReturn = i18n.t('general.dialogComponent.text_error')
        break
    }
    return strToReturn
  }
}
